import React from "react";
import { Box } from "@mui/material";
import ContactUs from "../components/ContactUs";
import SocialMediaBar from "../components/SocialMediaBar";

const contactDetails = [
  "+234 913 504 0637",
  "baniluxillumina2@gmail.com",
  "+234 816 944 4534",
];

const Footer = () => {
  return (
    <Box
      sx={{
        width: "100%",
        // position: "fixed",
        bottom: 0,
        zIndex: 1002,
        backgroundColor: "rgb(25, 25, 25)",
      }}
    >
      {/* <ContactUs contactDetails={contactDetails} /> */}
      <SocialMediaBar />
      <Box
        sx={{
          width: "100%",
          fontSize: "0.75rem",
          color: "white",
          textAlign: "center",
          margin: "1rem auto",
        }}
      >
        &copy; {new Date().getFullYear()} Banilux Illumina
      </Box>
    </Box>
  );
};

export default Footer;
